import { IntlTFunc } from 'next-intl';

import { SimpleProductFragment, ProductStockStatus } from '@/fo/api/magento';

import { utilMapSimpleProductData } from '../lib/utilMapSimpleProductData';
import { ConfigurableVariants, ProductsMindbox } from '../types';

export const configurableVariantsMapper = (
  configurableVariants: ConfigurableVariants,
  t: IntlTFunc,
  mindboxProducts?: ProductsMindbox,
  options?: { preselectFirstInStock?: boolean; selectedSku?: string }
) => {
  const preselect = options?.preselectFirstInStock ?? true;
  const selectedSku = options?.selectedSku?.trim();
  const hasSelectedSku = Boolean(
    selectedSku &&
      configurableVariants.some(
        (variant) =>
          (variant?.product as SimpleProductFragment)?.sku === selectedSku
      )
  );
  let selected = false;

  return configurableVariants
    .filter(
      (v) => !!v && !!v.product && !!v.attributes && v.attributes.length > 0
    )
    .map((variant) => {
      const product = variant?.product as SimpleProductFragment;
      const sku = product?.sku ?? '';
      const inStock = product?.stockStatus === ProductStockStatus.InStock;

      const isSelected = hasSelectedSku
        ? sku === selectedSku
        : preselect
          ? !selected && inStock
          : false;

      if (isSelected) selected = true;

      return {
        sku,
        label: variant?.attributes?.[0]?.label ?? '',
        stockStatus: product?.stockStatus ?? null,
        isSelected,
        product: utilMapSimpleProductData(product, t, mindboxProducts)
      };
    });
};
